import { giphyBlack } from '@giphy/js-brand'
import styled, { css } from 'styled-components'
import { brightnessFromColor } from 'utils'
import IconButton from '../../icon-button'

export const Header = styled.div<{ controlColor: string }>`
    align-items: stretch;
    display: flex;

    &:not(:only-child) {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    }

    ${({ controlColor }) => {
        const color = brightnessFromColor(controlColor) > 0.5 ? giphyBlack : '#fff'

        return css`
            background: ${controlColor};
            color: ${color};
        `
    }}
`

export const Button = styled(IconButton)<{ isOpen: boolean }>`
    flex-shrink: 0;
    height: auto;

    svg {
        transform: rotate(${({ isOpen }) => (isOpen ? 180 : 0)}deg);
        transition: transform 0.15s ease-out;
    }
`

export const Label = styled.div`
    margin: auto 0;
    width: 100%;
`

export const LabelText = styled.div`
    align-self: center;
    box-sizing: border-box;
    overflow: hidden;
    padding: 0 1em;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
`
